import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import ColorPicker from "web/react/components/color-picker/color-picker";
import OOSBuyOptionsRail from "web/react/components/oos-buy-options-rail/oos-buy-options-rail";
import OOSImage from "web/react/components/oos-image/oos-image";
import SaveForLaterButton from "web/react/components/save-for-later-button/save-for-later-button";
import { gettext } from "web/script/modules/django-i18n";
import { languageIsEnglish } from "web/script/modules/language";
import userProfiler from "web/script/modules/userprofiler";
import { BuyOptionPropType } from "web/types/buy-option";
import { ColorVariantPropType } from "web/types/color-variant";
import { DesignerPropType } from "web/types/designer";
import { ProductPropType } from "web/types/product";
import { ProductCardPropType } from "web/types/product-card";
import styles from "./oos-product-area.css";


export const OOSProductAreaPropType = PropTypes.shape({
    absolute_url: PropTypes.string.isRequired,
    buy_options: PropTypes.objectOf(BuyOptionPropType).isRequired,
    color_variants: PropTypes.arrayOf(ColorVariantPropType),
    designer: DesignerPropType.isRequired,
    is_saved_for_later: PropTypes.bool.isRequired,
    product: ProductPropType.isRequired,
    sorted_buy_options: PropTypes.arrayOf(PropTypes.string).isRequired,
    stores_checked: PropTypes.number.isRequired,
    previously_seen_title: PropTypes.string.isRequired,
});

function OOSProductArea({
    className,
    productArea: {
        buy_options: buyOptions,
        product,
        designer,
        is_saved_for_later: isSavedForLater,
        sorted_buy_options: sortedBuyOptions,
        color_variants: colorVariants,
        previously_seen_title: previouslySeenTitle,
    },
    galleryRelated,
}) {
    let isLoggedIn = React.useMemo(() => userProfiler.isLoggedIn(), []);
    const showColorVariants =
        colorVariants &&
        colorVariants.length > 1 &&
        colorVariants.filter((variant) => variant.in_stock).length > 1;

    return (
        <div className={classnames(styles.wrapper, className)}>
            <div className={styles.hero}>
                <h4>{"TODO - Hero component"}</h4>
                {/* A h4 tag before the main h1 may be strange for google */}
            </div>
            <div className={styles.descriptionAndColorPicker}>
                <div className={styles.descriptionAndImage}>
                    <div className={styles.smallImage}>
                        <OOSImage product={product} relatedProducts={galleryRelated} />
                    </div>
                    <span className={styles.description}>
                        <h1>
                            {/* This is h1 in jinja file, important for SEO */}
                            {/* TODO -GOOGLE METADATA */}
                            <span className={styles.designerName}>
                                {designer.active && designer.url ? (
                                    <a href={designer.url}>{designer.name}</a>
                                ) : (
                                    <span>{designer.name}</span>
                                )}
                            </span>{" "}
                            <span className={styles.shortDescription}>
                                {product.short_description}
                            </span>
                        </h1>
                        {languageIsEnglish() && (
                            <SaveForLaterButton
                                cta={gettext("oos_product.get_stock_alerts_btn")} // Get stock alerts
                                type="stockAlert"
                                pageSource="oos"
                                isLoggedIn={isLoggedIn}
                                productId={product.product_id}
                                isSaved={isSavedForLater}
                            />
                        )}
                    </span>
                </div>
                {showColorVariants && (
                    <div className={styles.colorPickerArea}>
                        <h3 className={styles.title}>
                            {// "Try another color?"
                                gettext("oos_product.try_another_color.title")}
                        </h3>
                        <ColorPicker
                            canonicalSlug={product.canonical_slug}
                            className={styles.colorPicker}
                            variants={colorVariants}
                            variantLimit={8}
                        />
                    </div>
                )}
            </div>
            <OOSBuyOptionsRail
                className={styles.buyOptions}
                buyOptions={buyOptions}
                sortedBuyOptions={sortedBuyOptions}
                previouslySeenTitle={previouslySeenTitle}
            />
        </div>
    );
}

OOSProductArea.propTypes = {
    className: PropTypes.string,
    galleryRelated: PropTypes.arrayOf(ProductCardPropType).isRequired,
    productArea: OOSProductAreaPropType.isRequired,
};

export default OOSProductArea;
